import React, { useEffect, useRef, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useCookies } from 'react-cookie';
import avatar from '../public/images/avatar5.png'
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { loadingChange, loadingLogoutChange, logout, modalChange } from '../redux/slices/AuthSlice';
import { currencyFormat } from '../Functions';
import { URL } from '../config';
import Loading from '../Screens/Loading';
import Message from './Message';
import Search from './Search';
import Auth from '../Screens/Auth/Auth';
const Navbar = () => {
  const dispatch=useDispatch();
  const {items_count,cart_total}=useSelector((state)=>state.CartReducer);
  const {currentUser,token}=useSelector((state)=>state.AuthReducer);
  const {setting,header_pages}=useSelector((state)=>state.SettingReducer);
  const [cookies, setCookie, removeCookie] = useCookies(['user']);
  const [searchFlag,setSearchFlag]=useState(false);
  const [logoutFlag,setLogoutFlag]=useState(false);
  const [categoryFlag,setCategoryFlag]=useState(null);
  const [popLeft,setPopLeft]=useState(false);

 const open_auth=()=>{
  setPopLeft(false);
  dispatch(modalChange());
 }
  const logoutHandel=()=>{
    setPopLeft(false);
    dispatch(loadingLogoutChange());
    console.log(token);
    axios.get(`${URL}/api/auth/logout`,{
      headers:{
          Authorization:`Bearer ${token}`,
          'Accept':'application/json',
         ' Content-Type':'application/json'
      }})
    .then(function (response) {
      console.log(response.data);
      if(response.data.success){
        dispatch(logout());
        setCookie('user', "", { path: '/' });
        setCookie('token', "", { path: '/' });         
      }
  
      dispatch(loadingLogoutChange());
    })
    .catch(function (error) {
      console.log('error');
      dispatch(loadingLogoutChange());
    });
  }

  const [navbar, setNavbar] = useState(false);
  const [mainCategories,setMainCategories]=useState([]);
  useEffect(()=>{
    window.addEventListener("scroll", changeBackground);
    axios.get(`${URL}/api/home/get_categories`)
    .then(function (response) {
      if(response.data.success){
        setMainCategories(response.data.data);
      }
        })
    .catch(function (error) {
        console.log('error');
      });
    },[])
    const divRef1 =useRef(null);
    const divRef2 =useRef(null);
    const changeBackground = () => {
      if (window.scrollY >= 200 ) {
        setNavbar(true);
      
      } else {
        setNavbar(false);
      
      }
    };
    return (

      <div className='fixed-top'>
        <Auth/>
          <Message/>
      <nav className={`navbar header  ${navbar?'d-lg-none':'d-lg-flex'}`} >
          <div className="container">
              <div className="header-links  d-flex d-md-none">
                    <Link to='/' style={{ textDecoration:'none'}}><img src={setting.logo} style={{ height:'60px' }}/></Link> 
              </div> 
              
              <div className='d-none d-lg-flex gap-4 ' >
                {header_pages.map((header_page)=>(
                  <NavLink  className={({ isActive }) =>
                    `page-link nav-link ${
                      isActive && "page-link-hover "
                    } `
                  } to={`/page/${header_page.term}/${header_page.id}`} >{header_page.name} </NavLink>
                ))}

              </div>
              <Search width='large'/>

              <div style={{ display:'flex',alignItems:'center',gap:'10px'}}>
                <Link to='/cart'>
                <i className="fa fa-cart-shopping bar cart" >
                  <div className='count'>{items_count}</div>
                  <div className='price'> {currencyFormat(cart_total)}<span>ج.م</span> </div>
                </i>
                </Link>
              
                {
                    currentUser?(
                      <div className='logout d-none d-sm-flex' onClick={()=>setLogoutFlag(!logoutFlag)} onCli>
                        <img src={currentUser.image?currentUser.image:avatar} alt=""/>
                        <h4 >{currentUser?.f_name?currentUser.f_name:currentUser?.email.slice(0, currentUser.email.indexOf('@')).slice(0,12)}</h4>
                        <i className="fa-solid fa-chevron-down " style={{ fontSize:'12px',marginLeft:'10px',color:'black' }}></i>
                        <ul className='logout-list' style={{ display:!logoutFlag&&'none',margin:0,padding:0}}>
                            <li>
                            <i className="fa-regular fa-user "></i>
                              <Link to="/profile">حسابى</Link>                         
                            </li> 
                            <li>
                             <i class="fa-solid fa-box"></i>
                              <Link to="/orders">طلباتى</Link>                         
                            </li> 
                            <li>
                            <i class="fa-solid fa-arrow-right-from-bracket"></i>  
                              <Link style={{ color:'goldenrod' }} onClick={logoutHandel}>تسجيل خروج</Link>                            
                              </li>                   
                        </ul>
                      </div>
                    
                    ):(
                      <button className='d-none d-sm-inline login-button m-0' onClick={open_auth}>تسجيل الدخول</button>
                    )
                  }
            
              
                {!searchFlag?(
                              <i className="fa fa-search  d-md-none bar" onClick={()=>setSearchFlag(true)} ></i>
                ):(
                  <i className="fa fa-xmark  d-md-none bar" onClick={()=>setSearchFlag(false)} ></i>
                )
                }   
                <i className="fa-solid fa-bars  d-lg-none bar"  onClick={()=>setPopLeft(true)}></i>
              
              </div>
          <div className=" popleft " ref={divRef2} style={{ right:popLeft&&'0'}} >
            <div className='pop-fill'>
            <div className="pt-2 pb-5 pe-1 ps-1 d-flex flex-sm-row-reverse justify-content-between align-items-center">
              {
              currentUser?(
                <div className='logout  d-sm-none' style={{ justifyContent:'flex-start' }}  onClick={()=>setLogoutFlag(!logoutFlag)} >
                <img src={currentUser.image?currentUser.image:avatar} alt=""/>
                <h4>{currentUser?.email.slice(0, currentUser.email.indexOf('@')).slice(0,15)}</h4>
                <i className="fa-solid fa-chevron-down " style={{ fontSize:'12px',marginLeft:'10px',color:'white' }}></i>
                <ul className='logout-list' style={{ display:!logoutFlag&&'none',margin:0,padding:0}}>
                          <li>
                          <i className="fa-regular fa-user"></i>
                            <Link style={{ color:'black' }} to="/profile">حسابى</Link>                         
                          </li> 
                          <li>
                             <i class="fa-solid fa-box"></i>
                              <Link to="/orders">طلباتى</Link>                         
                            </li> 
                          <li>
                          <i class="fa-solid fa-arrow-right-from-bracket"></i>  
                            <Link onClick={logoutHandel} style={{ color:'black' }}>تسجيل خروج</Link>                            
                            </li>                   
                      </ul>
                  </div>
                    ):(
                      <button className=' d-sm-none login-button ' onClick={open_auth} style={{ margin:0 }}>تسجيل الدخول</button>
                    )}
                  <i className="fa-solid fa-xmark " onClick={()=>setPopLeft(false)}></i>
                    </div>
              <div className="offcanvas-body" style={{ padding:'0px' }}>
                <ul className="navbar-nav justify-content-end flex-grow-1 ">
        
                    <li className='nav-item'><NavLink  to='/all_products'
                className={({isActive}) =>isActive?"selected nav-link":"nav-link"} onClick={()=>setPopLeft(false)}> 
                جميع المنتجات
                </NavLink></li>
              
                  {mainCategories.map((mainCategory,idx)=>(
                  <li  >
                    <div className='nav-item d-flex justify-content-between'>
                    <NavLink  
                    className={({isActive}) =>isActive ? "selected nav-link":"nav-link"}
                    to={`/main_category/${mainCategory.id}/${mainCategory.name}`}
                      style={{ display:''}}
                      onClick={()=>setPopLeft(false)}
                      >
                      {mainCategory.name}
                      </NavLink>
                      {mainCategory.categories.length!=0?(
                      <div>
                      {categoryFlag!=idx?(
                        <i className="fa-solid fa-chevron-down chev" onClick={()=>{categoryFlag===idx?setCategoryFlag(null):setCategoryFlag(idx)}} style={{ fontSize:'15px' }}></i>
      
                        ):(
                          <i className="fa-solid fa-chevron-up chev" onClick={()=>{categoryFlag===idx?setCategoryFlag(null):setCategoryFlag(idx)}}  style={{ fontSize:'15px' }}></i>
      
                        )} 
                      </div>
                   ):''}
                  </div>
                  <ul className='nav-ul' style={{ display:categoryFlag!=idx&&'none',margin:0}}>
                    {mainCategory.categories.map((category)=>(
                        <li><NavLink onClick={()=>setPopLeft(false)}  className={({isActive}) =>isActive && "selected"} to={`/category/${mainCategory.id}/${mainCategory.name}/${category.id}/${category.name}`}>{category.name}</NavLink></li>
      
                   ))}
                  </ul>
              
                </li>
              ))}        
              </ul>  
              {/* {currentUser&&(
              <button className=' d-sm-none login-button'
              onClick={logoutHandel}
               style={{ margin:0,color:'white',position:'absolute',bottom:0,left:0,border:'none'}}>تسجيل خروج</button>
              )} */}
            </div>  
          </div>
          <div className='pop-space'  onClick={()=>setPopLeft(false)}> 

          </div>
                  
          </div>
        </div>
</nav>


<div className='  search-small  d-md-none mt-1' style={{top:searchFlag?'50px':'-100px'}}>
<Search width='small'/>      
</div>
<div className={`catagories  d-none d-lg-flex justify-content-between`} style={{transition:'2s'}} >
           <div className='container d-flex justify-content-between  align-items-center gap-4 '>
           <div className="header-links  d-flex">
                  <Link to='/' style={{ textDecoration:'none'}}><img src={setting.logo} style={{ height:'60px' }}/></Link> 
            </div> 
             <ul >
              <li><NavLink  to='/all_products'
               className={({isActive}) =>isActive && "selected"}> 
              جميع المنتجات
              </NavLink></li>
              {/* <li><NavLink to='/'>وصل حديثاً</NavLink></li> */}
              {mainCategories.map((mainCategory)=>(
                <li className='pops-down'>
                  <NavLink  className={({isActive}) =>isActive && "selected"} to={`/main_category/${mainCategory.id}/${mainCategory.name}`}>
                    {mainCategory.name}
                    {mainCategory.categories.length!=0?(
                    <i className="fa-solid fa-chevron-down " style={{ fontSize:'9px',marginRight:'10px' }}></i>
                    ):''}
                    </NavLink>
                  <ul>
                    {mainCategory.categories.map((category)=>(
                        <li><NavLink  style={{padding:'10px',fontSize:'14px'}} className={({isActive}) =>isActive && "selected"} to={`/category/${mainCategory.id}/${mainCategory.name}/${category.id}/${category.name}`}>{category.name}</NavLink></li>
                    ))}
                  </ul>
              
                </li>
              ))}        
              
             </ul>
             <div className={`${navbar?'d-flex gap-3 align-items-center':'d-none'}`} style={{ gap:'10px' }}>
            <Link to='/cart'>
              <i className="fa fa-cart-shopping bar cart" style={{color:'black'}}>
                <div className='count' style={{color:'white'}}>{items_count}</div>
                <div className='price'> {currencyFormat(cart_total)}<span>ج.م</span> </div>
              </i>
              </Link>
            
              {
                  currentUser?(
                    <div className='logout d-none d-sm-flex' onClick={()=>setLogoutFlag(!logoutFlag)} onCli>
                      <img src={currentUser.image?currentUser.image:avatar} alt=""/>
                      <h4 >{currentUser.email.slice(0, currentUser.email.indexOf('@')).slice(0,12)}</h4>
                      <i className="fa-solid fa-chevron-down " style={{ fontSize:'12px',marginLeft:'10px',color:'black' }}></i>
                      <ul className='logout-list' style={{ display:!logoutFlag&&'none',margin:0,padding:0}}>
                          <li>
                          <i className="fa-regular fa-user"></i>
                            <Link to="/profile">حسابى</Link>                         
                          </li> 
                          <li>
                             <i class="fa-solid fa-box"></i>
                              <Link to="/orders">طلباتى</Link>                         
                            </li> 
                          <li>
                          <i class="fa-solid fa-arrow-right-from-bracket"></i>  
                            <Link  onClick={logoutHandel}>تسجيل خروج</Link>                            
                            </li>                   
                      </ul>
                    </div>
                  
                  ):(
                    <button className='d-none d-sm-inline login-button' style={{color:'black',borderColor:'black'}} onClick={open_auth}>تسجيل الدخول</button>
                  )
                }
            </div>
            </div>
            
</div>

</div>
  )
}

export default Navbar
